




































import { Component, Prop, Vue } from "vue-property-decorator";
import ListImplementasiMpp from "@/components/mpp/ListImplementasiMpp.vue";

@Component({
  components: { ListImplementasiMpp }
})
export default class ImplementasiMppModal extends Vue {
  @Prop({ type: Boolean, default: false }) value!: boolean;
  @Prop({ type: Array, default: () => [] }) items!: any[];
  @Prop({ type: Boolean, default: false }) isReadonly!: boolean;

  get dialog(): boolean {
    return this.value;
  }

  set dialog(val: boolean) {
    this.$emit("input", val);
  }
}
